<kendo-dialog title="Impersonate User" [height]="'auto'" [maxHeight]="'80vh'" [width]="900"(close)="closeDialog()">
         <div class="k-mb-4">
    <form class="staff-form" [formGroup]="form" (ngSubmit)="getUsersToImpersonate()">
      <kendo-formfield >
        <kendo-floatinglabel text="First Name">
          <kendo-textbox [clearButton]="true" [fillMode]="'outline'" [class]="'k-pr-2'" formControlName="firstName"
           >
          </kendo-textbox>
        </kendo-floatinglabel>
        <!-- <div class="form-error-slot">
          <kendo-formerror>
            {{ form.get("firstName")?.errors?.validateName?.message }}
          </kendo-formerror>
        </div> -->
      </kendo-formfield>

      <kendo-formfield >
        <kendo-floatinglabel text="Last Name">
          <kendo-textbox [clearButton]="true" [fillMode]="'outline'" formControlName="lastName"
           >
          </kendo-textbox>
        </kendo-floatinglabel>
        <!-- <div class="form-error-slot">
          <kendo-formerror>
            {{ form.get("lastName")?.errors?.validateName?.message }}
          </kendo-formerror>
        </div> -->
      </kendo-formfield>

      <div class="or-wrapper">
        <div class="or-icon"></div>
        <div class="form-error-slot"></div>
      </div>

      <kendo-formfield>
        <kendo-floatinglabel text="Email">
          <kendo-textbox [clearButton]="true" [fillMode]="'outline'" formControlName="email"
           >
          </kendo-textbox>
        </kendo-floatinglabel>
        <!-- <div class="form-error-slot">
          <kendo-formerror>
            {{ form.get("email")?.errors?.validateEmail?.message }}
          </kendo-formerror>
        </div> -->
      </kendo-formfield>

      <button kendoButton [fillMode]="'outline'" [themeColor]="'primary'" class="search-btn">
          @if (loadingUsers) {
          <kendo-loader size="small"></kendo-loader>
          }
        Search
      </button>
    </form>
    <kendo-formerror *ngIf="form?.invalid || showSearchError">
      Please input valid name or email to search</kendo-formerror>
  </div>
  <kendo-grid [data]="gridView" *ngIf="gridView" [loading]="loadingUsers" [pageSize]="pageSize" [skip]="skip" class="impersonate-grid"
    [pageable]="{ buttonCount: 6, type: 'numeric', pageSizes: true }" (pageChange)="onPageChange($event)">

    <kendo-grid-column field="userName" title="User Name" [width]="120">
      <ng-template kendoGridCellTemplate let-data>
        <div [title]="data?.userName" kendoTooltip position="bottom">{{data?.userName}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="firstName" title="First Name" [width]="100">
      <ng-template kendoGridCellTemplate let-data>
        <div [title]="data?.firstName" kendoTooltip position="bottom">{{data?.firstName}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastName" title="Last Name" [width]="100">
      <ng-template kendoGridCellTemplate let-data>
        <div [title]="data?.lastName" kendoTooltip position="bottom">{{data?.lastName}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="email" title="Email" [width]="180">
      <ng-template kendoGridCellTemplate let-data>
        <div [title]="data?.email" kendoTooltip position="bottom">{{data?.email}}</div>
      </ng-template>
    </kendo-grid-column>

    <!-- <kendo-grid-column title="Roles">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="k-my-2" *ngFor="let role of getDistinctRoles(dataItem?.roles)">
        {{ role }}
      </div>
    </ng-template>
  </kendo-grid-column> -->

    <kendo-grid-column title="Actions" [width]="80">
      <ng-template kendoGridCellTemplate let-data>
        <button kendoButton themeColor="primary" [title]="'Impersonate'" (click)="impersonate(data)" [size]="'small'"
          [svgIcon]="faUserSecret"></button>
      </ng-template>
    </kendo-grid-column>

  </kendo-grid>
  <!-- <kendo-dialog-actions>
    <div class="k-d-flex k-justify-content-between">
        <button kendoButton (click)="closeDialog()">Cancel</button>
        <button kendoButton themeColor="primary" [disabled]="!selectedUser" (click)="impersonate()">Impersonate</button>
    </div>
</kendo-dialog-actions> -->
</kendo-dialog>